// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3PGDb","list":"BalanceDue_list__pgHjg","listRow":"BalanceDue_listRow__2vESz","total":"BalanceDue_total__3jpiG"};